var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_customForm_lsit_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-admin-custom-form-type"),
      filterable: "",
      exportBtn: _vm.hasBtn("export-admin-custom-form-type"),
    },
    on: {
      new: _vm.toNew,
      filter: function (val) {
        _vm.filterPageData = val
      },
      export: _vm.exportOut,
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                "filter-page-data": _vm.filterPageData,
                showSelect: _vm.showSelect,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "table-title text--primary",
                          attrs: {
                            title: _vm.$getCommonLangValue(
                              item.application_type_name
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(
                                  item.application_type_name
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.code",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(_vm._s(_vm.$getCommonLangValue(item.type_code))),
                    ]
                  },
                },
                {
                  key: "item.approval_flow",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(
                          _vm.$getCommonLangValue(
                            item.flow_template_name
                              ? item.flow_template_name
                              : item.flow_template_uuid
                          )
                        )
                      ),
                    ]
                  },
                },
                {
                  key: "item.status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("StatusChip", {
                        attrs: {
                          icon: "",
                          "show-icon": false,
                          "text-color": "white--text",
                          bgColor: Number(item.status) === 1 ? "green" : "grey",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "status",
                              fn: function () {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        Number(item.status) === 1
                                          ? _vm.$t(
                                              "label_essweb_system_status_onLabel"
                                            )
                                          : _vm.$t(
                                              "label_essweb_system_status_offLabel"
                                            )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          delBtn: _vm.hasBtn("delete-admin-custom-form-type"),
                          editBtn: _vm.hasBtn("edit-admin-custom-form-type"),
                          viewBtn: _vm.hasBtn("view-admin-custom-form-type"),
                          otherText:
                            "label_essweb_customForm_lsit_previewBtnLabel",
                          title: _vm.$t("label_essweb_customForm_lsit_title"),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toEdit,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }